<template>
  <v-textarea
    @input.native="$emit('input', $event.target.value)"
    :label="label"
    :placeholder="placeholder"
    :rules="rules"
    :disabled="disabled"
    v-model="valor"
    background-color="white"
    dense
    flat 
    :reverse="reverse"
    :rows="rows"
    autocomplete="disable-autocomplete"
  ></v-textarea>
</template>
<style lang="sass">
.primary-text
  color: #4b3b72 !important
</style>
<script>
export default {
  name: "TextArea",
  props: {
    placeholder: String,
    label: String,
    reverse: Boolean,
    rules: Array,
    value: [String, Number, Array, Object],
    rows: [Number, String],
    disabled: Boolean
  },
  data: function () {
    return {
      valor: "",
    };
  },
  methods: {
    removerAcentos($event) {
      if (!this.semAcentos) return true;
      let caractere = $event.key.toLowerCase();

      const parsed = $event.key
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();

      if (caractere != parsed) $event.preventDefault();
    },
  },
  watch: {
    valor: {
      immediate: true,
      handler(novoValor) {
        this.$emit("input", novoValor);
      },
    },
    value: {
      immediate: true,
      handler(val) {
        this.valor = val;
      },
    },
  },
};
</script>
